import moment from 'shared/utils/moment';

/**
 * A facade to a Moment date object set to CET time.
 * Supports a subset of the native Date API for backwards compatibility.
 * @param {number} epoch Optional unix epoch timestamp.
 */
export default class MomentDate {
  constructor(epoch) {
    this.moment = moment.utc(epoch);
    this.moment.tz('Europe/Stockholm');
  }

  getTime() {
    return moment(this.moment).valueOf();
  }

  getFullYear() {
    return this.moment.year();
  }

  getMonth() {
    return this.moment.month();
  }

  getDate() {
    return this.moment.date();
  }

  getHours() {
    return this.moment.hours();
  }

  getMinutes() {
    return this.moment.minutes();
  }

  getSeconds() {
    return this.moment.seconds();
  }

  toISOString(keepOffset) {
    return this.moment.toISOString(keepOffset);
  }
}
